import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: '[app-dispatcher-table]',
    templateUrl: './dispatcher-table.component.html',
    styleUrls: ['./dispatcher-table.component.css'],
    standalone: false
})
export class DispatcherTableComponent implements AfterViewInit
{
  public viewMode = "cards";

  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "DispatcherTable" }));
  }
}
